import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Custom hook to handle MAC address to device ID redirect
 * If deviceId is a MAC address (contains colons), finds the device and redirects with proper device ID
 * Automatically preserves the current path and all other query parameters
 *
 * @param {string} deviceId - The device ID or MAC address from query params
 * @param {object} device - The device object containing devices array
 */
export function useDeviceIdRedirect(deviceId, device) {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Only process if we have a deviceId that looks like a MAC address
    if (!deviceId || !deviceId.includes(':') || !device?.devices) {
      return;
    }

    // Find device by MAC address
    const foundDevice = device.devices.find(d => d.macAddress === deviceId);

    if (foundDevice && foundDevice._id) {
      // Get current search params and swap out the deviceId
      const params = new URLSearchParams(location.search);
      params.set('deviceId', foundDevice._id);

      // Redirect to same path with updated deviceId
      const newUrl = `${location.pathname}?${params.toString()}`;
      history.replace(newUrl);
    }
  }, [deviceId, device, history, location.pathname, location.search]);
}
